import { Helpers } from '../../helpers';
import { IRigRampStatus } from '../../interfaces/irig-ramp-status';
import { Well } from '../well';

export class RigRampStatusBase {
  RigRampStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Wells_RigRampStatus?: Array<Well> | null;

  constructor(item?: IRigRampStatus) {
    if (item) {

      this.RigRampStatusId = item.RigRampStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Wells_RigRampStatus = Helpers.createClassArray(Well, item.Wells_RigRampStatus);
    }
  }
}